import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";
import { DropShadowFilter } from "pixi-filters";

export class TextsContainer extends Container {
    private static readonly INTRODUCING_TEXT = "INTRODUCING A NEW";
    private static readonly GUEST_FEATURE_TEXT = "QUEST FEATURE";
    private static readonly FOR_RENTERS_TEXt = "FOR RENTERS!";
    private static readonly COLLECT_TEXT = "COLLECT";
    private static readonly UPGRADE_POINTS_TEXT = "UPGRADE POINTS";
    private static readonly FROM_UPGRADE_ACTION = `FROM ANY UPGRADES MADE\nIN THE NEXT`;
    private static readonly DAYS_TEXT = "DAYS";
    private static readonly COMPLETE_FIRST_TEXT = "COMPLETE THE QUEST TO";
    private static readonly COMPLETE_SECOND_TEXT = "PROGRESS IN GAME, AND AVOID";
    private static readonly COMPLETE_THIRD_TEXT = "PENALTIES FOR NON-COMPLETION";

    private readonly requiredUpgradePoints: number;
    private readonly durationInHours: number;

    public constructor(
        requiredUpgradePoints: number,
        durationInHours: number
    ) {
        super();
        this.requiredUpgradePoints = requiredUpgradePoints;
        this.durationInHours = durationInHours;
        this.buildTexts();
    }

    private buildTexts(): void {
        const introducingText = new Text(TextsContainer.INTRODUCING_TEXT, new WhiteTextStyle());

        const guestFeatureText = new Text(TextsContainer.GUEST_FEATURE_TEXT, new PurpleTextStyle());
        guestFeatureText.position.set(291, -26);

        const forRentersText = new Text(TextsContainer.FOR_RENTERS_TEXt, new WhiteTextStyle());
        forRentersText.position.set(0, 48);

        const collectText = new Text(TextsContainer.COLLECT_TEXT, new WhiteTextStyle());
        collectText.position.set(386, 63);

        const upgradePointsText = new Text(`${StringFormatExtention.abbreviatedFormat(this.requiredUpgradePoints).toUpperCase()} ${TextsContainer.UPGRADE_POINTS_TEXT}`, new GreenTextStyle());
        upgradePointsText.position.set(0, 141);

        const fromUpgradeActionText = new Text(TextsContainer.FROM_UPGRADE_ACTION, new WhiteTextStyle());
        fromUpgradeActionText.style.fontSize = 61;
        fromUpgradeActionText.style.lineHeight = 48;
        fromUpgradeActionText.position.set(5, 204);

        const totalHoursText = new Text(`${Math.round(this.durationInHours / 24)} ${TextsContainer.DAYS_TEXT}`, new OrangeTextStyle());
        totalHoursText.position.set(5, 295);

        const completeTextFirst = new Text(TextsContainer.COMPLETE_FIRST_TEXT, new WhiteWithShadowTextStyle());
        completeTextFirst.style.fontSize = 70;
        completeTextFirst.position.set(0, 537);
        completeTextFirst.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0x52dcff })];

        const completeTextSecond = new Text(TextsContainer.COMPLETE_SECOND_TEXT, new WhiteWithShadowTextStyle());
        completeTextSecond.style.fontSize = 56;
        completeTextSecond.position.set(0, 604);
        completeTextSecond.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0x52dcff })];

        const completeTextThird = new Text(TextsContainer.COMPLETE_THIRD_TEXT, new WhiteWithShadowTextStyle());
        completeTextThird.style.fontSize = 52;
        completeTextThird.position.set(0, 659);
        completeTextThird.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0x52dcff })];

        this.updateTextRotation([
            introducingText,
            guestFeatureText,
            forRentersText,
            collectText,
            upgradePointsText,
            fromUpgradeActionText,
            totalHoursText,
            completeTextFirst,
            completeTextSecond,
            completeTextThird
        ]);

        this.addChild(
            introducingText,
            guestFeatureText,
            forRentersText,
            collectText,
            upgradePointsText,
            fromUpgradeActionText,
            totalHoursText,
            completeTextFirst,
            completeTextSecond,
            completeTextThird
        )
    }

    private updateTextRotation(texts: Array<Text>): void {
        for (const text of texts) {
            text.angle = -5;
            text.skew.x = -0.08;
        }
    }
}

class WhiteTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "left",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 47
        }));
    }
}

class GreenTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: [
                "#02ffba",
                "#22fd7b"
            ],
            fillGradientType: 1,
            fillGradientStops: [
                0,
                0.8
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 76
        }));
    }
}

class OrangeTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: [
                "#fe7934",
                "#f72775"
            ],
            fillGradientType: 1,
            fillGradientStops: [
                0,
                0.8
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 245
        }));
    }
}

class PurpleTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#FE52E3",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 47
        }));
    }
}

class WhiteWithShadowTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 47,
            dropShadow: true,
            dropShadowAngle: 0,
            dropShadowBlur: 20,
            dropShadowColor: "#52dcff",
            dropShadowDistance: -3,
            padding: 20,
        }));
    }
}
